// src/pages/Home.jsx — Broadway Holidays
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import SearchWidget from "../components/SearchWidget";
import useWeather from "../hooks/useWeather";
import "./Home.css";

const TODAY = new Date();
const addD  = (d,n) => { const x=new Date(d); x.setDate(x.getDate()+n); return x; };
const fmt   = d => d.toISOString().split("T")[0];
const CI    = fmt(addD(TODAY,30));
const CO    = fmt(addD(TODAY,37));

// ── Destinations — images verified against real Unsplash listings for
// each exact place; lat/lon are real coordinates used for live weather ──
const DESTINATIONS = [
  { name:"Antalya",       country:"Turkey",   img:"https://images.unsplash.com/photo-1644522236794-3a120ab06744?w=800&h=600&fit=crop&q=90", hot:true,  vibe:"Beach",     price:389,  dealMonth:"Nov", dealPrice:349, lat:36.8969, lon:30.7133  },
  { name:"Maldives",      country:"Maldives", img:"https://images.unsplash.com/photo-1470214203634-e436a8848e23?w=800&h=600&fit=crop&q=90", hot:true,  vibe:"Beach",     price:1199, dealMonth:"Jun", dealPrice:949, lat:4.1755,  lon:73.5093  },
  { name:"Dubai",         country:"UAE",      img:"https://images.unsplash.com/photo-1745750434535-5943ef2fd31a?w=800&h=600&fit=crop&q=90", hot:true,  vibe:"City",      price:549,  dealMonth:"Aug", dealPrice:469, lat:25.2048, lon:55.2708  },
  { name:"Tenerife",      country:"Spain",    img:"https://images.unsplash.com/photo-1661075108456-a59effb64e96?w=800&h=600&fit=crop&q=90", hot:false, vibe:"Beach",     price:349,  dealMonth:"Jan", dealPrice:289, lat:28.4636, lon:-16.2518 },
  { name:"Majorca",       country:"Spain",    img:"https://images.unsplash.com/photo-1558175988-38675f14812b?w=800&h=600&fit=crop&q=90", hot:false, vibe:"Beach",     price:379,  dealMonth:"Oct", dealPrice:319, lat:39.5696, lon:2.6502   },
  { name:"Rhodes",        country:"Greece",   img:"https://images.unsplash.com/photo-1680205415325-3ceebea06319?w=800&h=600&fit=crop&q=90", hot:false, vibe:"Beach",     price:349,  dealMonth:"Sep", dealPrice:299, lat:36.4341, lon:28.2176  },
  { name:"Lanzarote",     country:"Spain",    img:"https://images.unsplash.com/photo-1651592753054-53ccf0b1f383?w=800&h=600&fit=crop&q=90", hot:false, vibe:"Beach",     price:359,  dealMonth:"Apr", dealPrice:309, lat:28.9630, lon:-13.5477 },
  { name:"Gran Canaria",  country:"Spain",    img:"https://images.unsplash.com/photo-1760721459142-28281c948866?w=800&h=600&fit=crop&q=90", hot:false, vibe:"Beach",     price:369,  dealMonth:"Jan", dealPrice:319, lat:28.1235, lon:-15.4363 },
  { name:"Fuerteventura", country:"Spain",    img:"https://images.unsplash.com/photo-1657626876898-0f26c7daf270?w=800&h=600&fit=crop&q=90", hot:false, vibe:"Beach",     price:355,  dealMonth:"Nov", dealPrice:299, lat:28.5004, lon:-13.8627 },
  { name:"Ibiza",         country:"Spain",    img:"https://images.unsplash.com/photo-1547138494-97041dec734b?w=800&h=600&fit=crop&q=90", hot:false, vibe:"Beach",     price:429,  dealMonth:"Oct", dealPrice:359, lat:38.9067, lon:1.4206   },
  { name:"Corfu",         country:"Greece",   img:"https://images.unsplash.com/photo-1695407591867-1399aad331f0?w=800&h=600&fit=crop&q=90", hot:false, vibe:"Beach",     price:339,  dealMonth:"May", dealPrice:279, lat:39.6243, lon:19.9217  },
  { name:"Phuket",        country:"Thailand", img:"https://images.unsplash.com/photo-1495296065068-ce70180981b7?w=800&h=600&fit=crop&q=90", hot:false, vibe:"Adventure", price:699,  dealMonth:"Sep", dealPrice:599, lat:7.8804,  lon:98.3923  },
];

const CITY_BREAKS = [
  { name:"Barcelona", country:"Spain",       img:"https://images.unsplash.com/photo-1764107183244-0cef642a99a9?w=800&h=600&fit=crop&q=90", vibe:"City",      price:249, dealMonth:"Feb", dealPrice:189, lat:41.3874, lon:2.1686   },
  { name:"Paris",     country:"France",      img:"https://images.unsplash.com/photo-1439393161192-32360eb753f1?w=800&h=600&fit=crop&q=90", vibe:"City",      price:259, dealMonth:"Jan", dealPrice:179, lat:48.8566, lon:2.3522   },
  { name:"Rome",      country:"Italy",       img:"https://images.unsplash.com/photo-1515542483964-5e8c63d7d89b?w=800&h=600&fit=crop&q=90", vibe:"City",      price:269, dealMonth:"Feb", dealPrice:199, lat:41.9028, lon:12.4964  },
  { name:"Lisbon",    country:"Portugal",    img:"https://images.unsplash.com/photo-1501415201023-2f45fbcefac0?w=800&h=600&fit=crop&q=90", vibe:"City",      price:229, dealMonth:"Mar", dealPrice:169, lat:38.7223, lon:-9.1393  },
  { name:"Amsterdam", country:"Netherlands", img:"https://images.unsplash.com/photo-1754835143820-bcf20e2e1a35?w=800&h=600&fit=crop&q=90", vibe:"City",      price:279, dealMonth:"Jan", dealPrice:209, lat:52.3676, lon:4.9041   },
  { name:"Marrakech", country:"Morocco",     img:"https://images.unsplash.com/photo-1760681556780-f27bf361131b?w=800&h=600&fit=crop&q=90", vibe:"Adventure", price:289, dealMonth:"Aug", dealPrice:229, lat:31.6295, lon:-7.9811  },
];

const ROULETTE_POOL = [...DESTINATIONS, ...CITY_BREAKS];
const ALL_PLACES = ROULETTE_POOL.map(({ name, lat, lon }) => ({ name, lat, lon }));

// Hero crossfade uses real destination photos — no stock generic image
const HERO_SLIDES = [
  DESTINATIONS.find(d => d.name === "Maldives").img,
  DESTINATIONS.find(d => d.name === "Antalya").img,
  DESTINATIONS.find(d => d.name === "Dubai").img,
  DESTINATIONS.find(d => d.name === "Rhodes").img,
];

// ── SVG Icons ─────────────────────────────────────────────
const HI = {
  Hotel: () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 22V8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14"/><path d="M3 22h18"/><path d="M9 22V12h6v10"/></svg>),
  Phone: () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2.18h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 9.91a16 16 0 0 0 6.16 6.16l1.91-1.91a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>),
  PoundCircle: () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9 12h4M9 16h6M10 8c0-1.1.9-2 2-2 1.1 0 2 .9 2 2 0 2-2 4-2 4"/></svg>),
  Shield: () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>),
  Globe:  () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>),
  Check:  () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>),
  Right: () => (<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>),
  TBed:   () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 4v16"/><path d="M2 8h18a2 2 0 0 1 2 2v10"/><path d="M2 17h20"/><path d="M6 8v9"/></svg>),
  TPound: () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M7 21h10"/><path d="M9 21c1.6-1 1.6-2.8.6-4.6"/><path d="M9.6 16.4H14"/><path d="M9.6 16.4c-.8-2.7.3-6.4 3.6-6.4 1.8 0 3.1.9 3.6 2.3"/></svg>),
  TPhone: () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.91a16 16 0 0 0 6.16 6.16l1.91-1.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>),
  TShield: () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>),
  TCalendar: () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>),
  WA: () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zM12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2 22l4.985-1.349A9.954 9.954 0 0 0 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2z"/></svg>),
};

// Weather condition → icon (line-style, matches the rest of the site)
const WEATHER_ICONS = {
  "clear": (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></svg>),
  "partly-cloudy": (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3v1M5.6 5.6l.7.7M3 12h1"/><path d="M17.5 19H8a4 4 0 1 1 .4-8 5.5 5.5 0 0 1 10.6 2.1A3.5 3.5 0 0 1 17.5 19z"/></svg>),
  "overcast": (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.5 19H8a4 4 0 1 1 .4-8 5.5 5.5 0 0 1 10.6 2.1A3.5 3.5 0 0 1 17.5 19z"/></svg>),
  "cloudy": (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.5 19H8a4 4 0 1 1 .4-8 5.5 5.5 0 0 1 10.6 2.1A3.5 3.5 0 0 1 17.5 19z"/></svg>),
  "fog": (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 8h18M3 12h18M3 16h11"/></svg>),
  "rain": (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 13v8M8 13v8M12 15v8"/><path d="M16.5 12H8a4 4 0 1 1 .4-8 5.5 5.5 0 0 1 10.6 2.1A3.5 3.5 0 0 1 16.5 12z"/></svg>),
  "snow": (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M8 16h.01M8 20h.01M12 18h.01M12 22h.01M16 16h.01M16 20h.01"/><path d="M16.5 10H8a4 4 0 1 1 .4-8 5.5 5.5 0 0 1 10.6 2.1A3.5 3.5 0 0 1 16.5 10z"/></svg>),
  "storm": (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M13 12l-3 5h4l-3 5"/><path d="M16.5 10H8a4 4 0 1 1 .4-8 5.5 5.5 0 0 1 10.6 2.1A3.5 3.5 0 0 1 16.5 10z"/></svg>),
};

function WeatherChip({ w }) {
  if (!w) return null;
  return (
    <span className="gh-weather-chip">
      {WEATHER_ICONS[w.condition] || WEATHER_ICONS.cloudy}
      {w.temp}°C
    </span>
  );
}

function DealBadge({ dest }) {
  return (
    <span className="gh-deal-badge">
      <HI.TCalendar />
      {dest.dealMonth} from £{dest.dealPrice}pp
    </span>
  );
}

// ── Sub-components ─────────────────────────────────────────
function BentoCard({ dest, big, wide, weather, onClick }) {
  const [err, setErr] = useState(false);
  return (
    <div
      className={`gh-bento-item${big ? " big" : ""}${wide ? " wide" : ""}`}
      onClick={() => onClick(dest.name)}
    >
      <img
        src={err ? "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=800&h=600&fit=crop" : dest.img}
        alt={dest.name} onError={() => setErr(true)} loading="lazy"
      />
      <div className="gh-bento-overlay" />
      {dest.hot && <span className="gh-bento-hot">HOT</span>}
      <DealBadge dest={dest} />
      <WeatherChip w={weather} />
      <div className="gh-bento-info">
        <span className="gh-bento-name">{dest.name}</span>
        <span className="gh-bento-country">{dest.country}</span>
      </div>
    </div>
  );
}

function CityScrollCard({ c, weather, onClick }) {
  const [err, setErr] = useState(false);
  return (
    <div className="gh-cscroll-card" onClick={() => onClick(c.name)}>
      <img
        src={err ? "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=800&h=600&fit=crop" : c.img}
        alt={c.name} onError={() => setErr(true)} loading="lazy"
      />
      <div className="gh-cscroll-overlay" />
      <DealBadge dest={c} />
      <WeatherChip w={weather} />
      <div className="gh-cscroll-info">
        <span className="gh-cscroll-name">{c.name}</span>
        <span className="gh-cscroll-country">{c.country}</span>
      </div>
    </div>
  );
}

function SectionHead({ title, sub, linkTo, linkLabel, dark }) {
  return (
    <div className="gh-sec-head">
      <div>
        <h2 className={`gh-sec-title${dark?" gh-sec-title-dark":""}`}>{title}</h2>
        {sub && <p className={`gh-sec-sub${dark?" gh-sec-sub-dark":""}`}>{sub}</p>}
      </div>
      {linkTo && (
        <Link to={linkTo} className={`gh-sec-link${dark?" gh-sec-link-dark":""}`}>
          {linkLabel || "View all"} <HI.Right/>
        </Link>
      )}
    </div>
  );
}

// ══════════════════════════════════════════════════════════
// MAIN HOME
// ══════════════════════════════════════════════════════════
export default function Home() {
  const navigate = useNavigate();
  const weatherMap = useWeather(ALL_PLACES);

  const goCity = name =>
    navigate(`/hotels?city=${encodeURIComponent(name)}&checkIn=${CI}&checkOut=${CO}&guests=2&rooms=1&mode=hotel`);

  return (
    <>
      <Navbar/>

      {/* HERO — crossfading real destination photos */}
      <section className="gh-hero">
        <div className="gh-hero-slides">
          {HERO_SLIDES.map((img, i) => (
            <div
              key={i}
              className="gh-hero-slide"
              style={{ backgroundImage: `url(${img})`, animationDelay: `-${i * 5}s` }}
            />
          ))}
        </div>
        <div className="gh-hero-overlay"/>
        <div className="gh-hero-inner">
          <div className="gh-hero-text">
            <h1 className="gh-hero-title">
              Your Dream <span className="gh-hero-accent">Holiday Awaits</span>
            </h1>
            <p className="gh-hero-sub">
              Search thousands of hotels worldwide — best prices guaranteed
            </p>
          </div>
          <div className="gh-hero-search">
            <SearchWidget defaultTab="hotel"/>
          </div>
        </div>
      </section>

      {/* TRUST BAR */}
      <div className="gh-trust-bar">
        {[
          { Icon:HI.TBed,    label:"1,000s of hotels worldwide" },
          { Icon:HI.TPound,  label:"Low deposits from £19pp" },
          { Icon:HI.TPhone,  label:"UK experts 7 days a week" },
          { Icon:HI.TShield, label:"Secure booking" },
        ].map((t,i) => (
          <div key={i} className="gh-trust-item">
            <span className="gh-trust-ico"><t.Icon/></span>
            <span className="gh-trust-lbl">{t.label}</span>
          </div>
        ))}
      </div>

      {/* POPULAR DESTINATIONS — bento grid */}
      <section className="gh-section">
        <div className="gh-container">
          <SectionHead
            title="Popular Holiday Destinations"
            sub="Hand-picked destinations with the best hotel deals"
            linkTo="/destinations"
            linkLabel="All destinations"
          />
          <div className="gh-bento">
            {DESTINATIONS.map((d, i) => (
              <BentoCard
                key={d.name}
                dest={d}
                big={i === 0}
                wide={i === 7}
                weather={weatherMap[d.name]}
                onClick={goCity}
              />
            ))}
          </div>
        </div>
      </section>

      {/* CITY BREAKS — scrollable carousel */}
      <section className="gh-section gh-section-grey">
        <div className="gh-container">
          <SectionHead
            title="City Breaks"
            sub="Short escapes to Europe's most vibrant cities"
            linkTo="/destinations"
          />
          <div className="gh-cscroll">
            {CITY_BREAKS.map(c => (
              <CityScrollCard key={c.name} c={c} weather={weatherMap[c.name]} onClick={goCity}/>
            ))}
          </div>
        </div>
      </section>

      {/* WHY BOOK WITH US */}
      <section className="gh-section">
        <div className="gh-container">
          <SectionHead title="Why Book With Broadway Holidays?"/>
          <div className="gh-why-grid">
            {[
              { Icon:HI.Hotel,       title:"Huge Hotel Selection",  body:"Thousands of hotels worldwide — from budget-friendly to luxury 5-star resorts." },
              { Icon:HI.PoundCircle, title:"Best Price Promise",    body:"Find it cheaper elsewhere? We'll match it — guaranteed." },
              { Icon:HI.Phone,       title:"UK Expert Advisors",    body:"Our team is available 7 days a week on 020 3019 0055." },
              { Icon:HI.Check,       title:"No Hidden Fees",        body:"What you see is what you pay. Fully transparent pricing every time." },
              { Icon:HI.Shield,      title:"Secure Booking",        body:"Your payment and personal details are always fully protected." },
              { Icon:HI.Globe,       title:"500+ Destinations",     body:"From Canary Islands sun to Maldives luxury — we cover the world." },
            ].map((w,i) => (
              <div key={i} className="gh-why-card">
                <div className="gh-why-ico"><w.Icon/></div>
                <h3 className="gh-why-title">{w.title}</h3>
                <p className="gh-why-body">{w.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA BANNER */}
      <section className="gh-cta">
        <div className="gh-cta-inner">
          <div>
            <h2 className="gh-cta-title">Can't find what you're looking for?</h2>
            <p className="gh-cta-sub">Our travel experts are ready to help you plan your perfect holiday</p>
          </div>
          <div className="gh-cta-btns">
            <a href="tel:02030190055" className="gh-cta-call">
              <HI.TPhone/> 020 3019 0055
            </a>
            <a href="https://wa.me/447487672075" target="_blank" rel="noreferrer" className="gh-cta-wa">
              <HI.WA/> WhatsApp Us
            </a>
          </div>
        </div>
      </section>

      {/* WhatsApp float */}
      <a href="https://wa.me/447487672075" target="_blank" rel="noreferrer" className="gh-wa-float" aria-label="Chat on WhatsApp">
        <span className="gh-wa-pulse"/>
        <svg width="30" height="30" viewBox="0 0 32 32" fill="#fff" xmlns="http://www.w3.org/2000/svg">
          <path d="M16 2C8.268 2 2 8.268 2 16c0 2.466.658 4.779 1.807 6.771L2 30l7.432-1.781A13.94 13.94 0 0 0 16 30c7.732 0 14-6.268 14-14S23.732 2 16 2zm0 25.5a11.44 11.44 0 0 1-5.84-1.6l-.42-.25-4.41 1.057 1.088-4.295-.274-.44A11.47 11.47 0 0 1 4.5 16C4.5 9.648 9.648 4.5 16 4.5S27.5 9.648 27.5 16 22.352 27.5 16 27.5zm6.29-8.61c-.346-.173-2.044-1.008-2.36-1.123-.317-.114-.547-.173-.778.173-.23.346-.892 1.122-1.094 1.353-.2.23-.402.26-.748.086-.346-.173-1.46-.538-2.782-1.717-1.028-.916-1.722-2.047-1.924-2.393-.201-.346-.022-.534.152-.706.156-.155.346-.403.52-.605.172-.201.23-.346.345-.577.116-.23.058-.432-.029-.605-.086-.173-.778-1.875-1.066-2.567-.28-.673-.565-.582-.778-.593l-.663-.012c-.23 0-.605.086-.922.432-.317.346-1.21 1.18-1.21 2.882 0 1.703 1.239 3.348 1.412 3.578.173.23 2.44 3.723 5.91 5.22.826.356 1.47.569 1.973.728.828.263 1.583.226 2.179.137.664-.1 2.044-.835 2.332-1.641.288-.807.288-1.499.202-1.641-.087-.144-.317-.23-.663-.403z"/>
        </svg>
      </a>

      <Footer/>
    </>
  );
}